<div [style.width]="props().width || '100%'">
  <mat-form-field appearance="outline">
    <input
      matInput
      autocomplete="no-autofill"
      [placeholder]="props()?.placeholder"
      [matAutocomplete]="auto"
      [formControl]="control"
      aria-label="Search Bar"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="suggestionSelected($event)">
        @for (suggestion of props()?.options; track suggestion) {
          <mat-option>
            @for (sugg of suggestion; track sugg) {
              <span>
                {{ sugg?.title }}
              </span>
            }
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
